export default "__VITE_ASSET__CWXHZ9jC__"